import React, { useEffect, useState } from "react";
import { auth } from "../firebaseConfig";
import { API_BASE_URL } from "../utils/apiBase";

const API_BASE = API_BASE_URL;

export default function QuestionImage({ question, quizId, context, alt = "Question", className, onImageClick }) {
  const mediaId = question?.questionMedia?.mediaId;
  const questionId = question?.questionId || question?.id;
  const legacy = !mediaId ? question?.questionImageURL || "" : "";
  const requestContext = JSON.stringify(context || null);
  const [source, setSource] = useState(legacy);

  useEffect(() => {
    if (!mediaId) { setSource(legacy); return undefined; }
    const resolvedContext = JSON.parse(requestContext);
    if ((!quizId && resolvedContext?.type !== "question-owner") || !questionId || !resolvedContext) {
      setSource(""); return undefined;
    }
    let active = true;
    let objectUrl = "";
    setSource("");
    (async () => {
      const user = auth.currentUser;
      if (!user) return;
      const token = await user.getIdToken();
      const response = await fetch(`${API_BASE}/api/question-media/deliver`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ quizId, questionId, context: resolvedContext }),
      });
      if (!response.ok) return;
      const blob = await response.blob();
      if (!active || !blob.type.startsWith("image/")) return;
      objectUrl = URL.createObjectURL(blob);
      setSource(objectUrl);
    })().catch(() => { if (active) setSource(""); });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [mediaId, legacy, quizId, questionId, requestContext]);

  if (!source) return null;
  return <img src={source} alt={alt} className={className}
    onClick={onImageClick ? () => onImageClick(source) : undefined} />;
}
